'use client'

import { Globe } from 'lucide-react'
import { useTranslations } from 'next-intl'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'

import { useLocale } from '@/hooks/use-locale'

import { cn } from '@/utils'

export const locales = ['en', 'ar'] as const
export type Locales = (typeof locales)[number]

export function LocaleSwitch({ className }: { className?: string }) {
  const t = useTranslations('components.localeSwitch')
  const { locale, setLocale, supportedLocales } = useLocale()

  return (
    <Select
      defaultValue={locale}
      onValueChange={(value: string) => setLocale(value as Locales)}
    >
      <SelectTrigger
        className={cn(
          'hover:bg-accent/20 w-full gap-2 rounded-lg transition-colors duration-200',
          className
        )}
      >
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4 shrink-0 opacity-70" />
        </div>
        <SelectValue placeholder={t('placeholder')} />
      </SelectTrigger>
      <SelectContent
        className="bg-background/95 border-border/40 min-w-[140px] backdrop-blur-sm"
        sideOffset={5}
      >
        {supportedLocales.map((language) => (
          <SelectItem
            className="hover:bg-accent/60 focus:bg-accent/60 cursor-pointer"
            key={language.key}
            value={language.key}
          >
            <span className="font-medium">
              {language.key === 'ar' ? t('arabic') : t('english')}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
